/* ============================================================
   cb-policy.js - Beleidspagina's (redesign 2026)

   Hoort bij sections/cb-policy.liquid. Eén taak, en die is optioneel:
   de knop "Cookievoorkeuren aanpassen" alleen tonen als er echt iets
   aan te passen valt.

   De mockup gaat uit van een cookiebanner. Dit thema heeft er geen; de
   winkel leunt op wat Shopify zelf meelevert. Die API laadt asynchroon,
   dus we luisteren naar visitorConsentCollected en kijken daarnaast na
   het laden nog een keer. Is er niets, dan blijft de knop weg: liever
   geen knop dan een knop die niets doet.
   ============================================================ */

(function () {
  'use strict';

  var button = document.querySelector('[data-cb-policy-consent]');
  if (!button) return;

  function privacyApi() {
    if (window.Shopify && window.Shopify.customerPrivacy) {
      return window.Shopify.customerPrivacy;
    }
    return null;
  }

  function reveal() {
    var api = privacyApi();
    if (!api || typeof api.showPreferences !== 'function') return false;
    button.hidden = false;
    return true;
  }

  button.addEventListener('click', function () {
    var api = privacyApi();
    if (api && typeof api.showPreferences === 'function') api.showPreferences();
  });

  if (!reveal()) {
    /* De API meldt zich zelf zodra hij klaar is. */
    document.addEventListener('visitorConsentCollected', reveal);
    /* En anders nog één keer kijken als de rest van de pagina geladen is. */
    window.addEventListener('load', reveal);
  }
})();
